import { HoverCard } from '@mantine/core'
import { Avatar, AvatarImg } from '@ow/comps'
import { useAppEx, useUser } from '@vt/hooks'
import { getQuery } from '@vt/utils'
import { isEmpty } from 'lodash-es'
import useRouteTo from '../../hooks/navigation/use-route-to'
import { UserDropDownItemStyle, LogoutStyled } from './styled/drop-down'
import userInfoBg from '../assets/user-info-bg.png'

const UserInfoItem = (props) => {
  const { label, value, isTab } = props
  return (
    <UserDropDownItemStyle className="flex flex-1">
      <span className="label">{label}</span>
      <span className="value break-all">
        {value}
        {isTab && <button type="button">切换</button>}
      </span>
    </UserDropDownItemStyle>
  )
}

const UserOperate = function ({ actions }) {
  const { appId } = useAppEx()
  const { routeTo } = useRouteTo(appId)
  const { logOut } = useUser()
  const { tpl } = getQuery()
  const switchApp = (action) => {
    console.log('action', action)
    routeTo({
      navType: 'push',
      url: `${action.url}&appId=${appId}`,
      project: 'web',
    })
  }

  return (
    <LogoutStyled>
      {actions.map((action, index) => (
        <span key={`action-${index}`} onClick={() => switchApp(action)}>
          {action.label}
        </span>
      ))}
      <span className="logout" onClick={() => logOut(tpl)}>
        退出登录
      </span>
    </LogoutStyled>
  )
}
const LOGOUT_ELEMENT = 'user_avatar_logout'
export default function (props) {
  const { userInfo, onMenuSelect, dropDown } = props
  const {
    name = '',
    username = '',
    loginName = '',
    mobile = '',
    type = '',
    nav = '',
    actions: operateActions = [],
  } = userInfo
  console.log('userInfo', userInfo)
  const userName = name || username || loginName
  const isLogoutVisible = type === LOGOUT_ELEMENT
  return (
    <HoverCard width={320} shadow="md" position="bottom-end" offset={12}>
      <HoverCard.Target>
        <span
          className="ml-6 cursor-pointer ow-text-inverse-color flex items-center justify-center"
          style={{ whiteSpace: 'nowrap' }}
        >
          <AvatarImg
            style={{
              backgroundColor: 'var(--ow-color-white-100)',
              borderRadius: '50%',
            }}
            userInfo={userInfo}
            className="flex justify-center items-center"
            fill="var(--ow-color-primary-700)"
          />
          <Avatar
            className="ml-2 overflow-ellipsis overflow-hidden"
            textColor="var(--ow-color-white-100)"
            style={{
              borderRadius: 0,
            }}
            userInfo={{
              name: userName,
            }}
          />
        </span>
      </HoverCard.Target>
      <HoverCard.Dropdown width={320} style={{ padding: 0, flexWrap: 'wrap' }}>
        <span
          className="flex items-center justify-left"
          style={{
            whiteSpace: 'nowrap',
            height: '88px',
            background: `url(${userInfoBg}) no-repeat center center`,
            backgroundSize: 'cover',
            padding: '0 0 0 24px',
            marginBottom: '8px',
          }}
        >
          <AvatarImg
            style={{
              backgroundColor: 'var(--ow-color-primary-800)',
              border: '1px solid var(--ow-color-neutral-100)',
              borderRadius: '50%',
            }}
            className="flex justify-center items-center"
            userInfo={{
              name: userName,
            }}
          />
          <Avatar
            className="ml-2 overflow-ellipsis overflow-hidden"
            style={{
              borderRadius: 0,
            }}
            textColor="var(--ow-color-darkTheme-1000)"
            userInfo={{
              name: userName,
            }}
            onClick={() => {
              if (nav) {
                onMenuSelect(nav)
              }
            }}
          />
        </span>
        {dropDown && !isEmpty(dropDown) ? (
          <>
            {dropDown.map((item) => (
              <UserInfoItem
                label={item.label}
                value={userInfo[item.type] || '-'}
              />
            ))}
          </>
        ) : (
          <>
            <UserInfoItem label="用户名" value={userName} />
            <UserInfoItem label="手机号" value={mobile} />
          </>
        )}
        {/* <UserInfoItem label="所属组织" value="检查团队" isTab /> */}
        {/* <UserInfoItem label="角色" value="项目管理员" /> */}
        {isLogoutVisible && <UserOperate actions={operateActions} />}
      </HoverCard.Dropdown>
    </HoverCard>
  )
}
